export const defaultCountsTimeLimitDays = 7;
export const countsTimeLimitDaysKey = "frends_processList_countsTimeLimitDays";

export function getCountsTimeLimitDaysFromStore() {
    const countsTimeLimitValueInStore = localStorage.getItem(countsTimeLimitDaysKey);
    if (!countsTimeLimitValueInStore) {
        return defaultCountsTimeLimitDays;
    }
    return parseInt(countsTimeLimitValueInStore);
}

export function setCountsTimeLimitDaysToStore(countsTimeLimitDays: number) {
    localStorage.setItem(countsTimeLimitDaysKey, countsTimeLimitDays.toString());
}
